export default [
  {
    path: '/tips',
    name: 'tips',
    component: () => import('../../views/tips/tips.vue'),
    meta: {
      pageTitle: 'Tips',
      breadcrumbs: ['Home', 'Tips'],
    },
    children:[
      {
        path: '',
        name: 'tips-list',
        component: () => import('../../views/tips/list.vue')
      },
      {
        path: 'create',
        name: 'tips-create',
        component: () => import('../../views/tips/create.vue'),
        meta: {
          pageTitle: 'Create Tips',
          breadcrumbs: ['Tips', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'tips-edit',
        component: () => import('../../views/tips/edit.vue'),
        meta: {
          pageTitle: 'Edit Tips',
          breadcrumbs: ['Tips', 'Edit'],
        }
      },
    ]
  }
]